import angular from 'angular';

var module = angular.module('app.peeps', []);

export default module;